/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lead_Search_PlaceholderInputs */

const cs_lead_search_placeholder = /** @type {(inputs: Lead_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat jméno, e-mail, telefon…`)
};

const en_lead_search_placeholder = /** @type {(inputs: Lead_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search name, email, phone…`)
};

/**
* | output |
* | --- |
* | "Search name, email, phone…" |
*
* @param {Lead_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lead_search_placeholder = /** @type {((inputs?: Lead_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lead_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lead_search_placeholder(inputs)
	return cs_lead_search_placeholder(inputs)
});